export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/sparse.js
// module id = 11
// module chunks = 0